import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FunctieSelectionDialogComponent } from './functie-selection-dialog.component';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
    declarations: [FunctieSelectionDialogComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [FunctieSelectionDialogComponent],
})
export class FunctieSelectionDialogModule { }